function normalizePrefix(prefix) {
  if (!prefix) {
    return ''
  }
  const value = prefix.startsWith('/') ? prefix : `/${prefix}`
  return value.endsWith('/') ? value.slice(0, -1) : value
}

function normalizePath(path) {
  if (!path) {
    return ''
  }
  return path.startsWith('/') ? path : `/${path}`
}

function normalizeBaseUrl(baseUrl) {
  return baseUrl && baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
}

function getHostname(url) {
  try {
    return new URL(url).hostname
  } catch (error) {
    return ''
  }
}

function isPrivateHost(hostname) {
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname.startsWith('10.') ||
    hostname.startsWith('192.168.') ||
    /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname)
  )
}

function isOnlineAuthApi(baseUrl) {
  const hostname = getHostname(baseUrl)
  return Boolean(hostname) && !isPrivateHost(hostname)
}

function resolveAuthApiPrefix(baseUrl) {
  const prefix = process.env.VUE_APP_AUTH_API_PREFIX
  if (prefix) {
    return normalizePrefix(prefix)
  }
  return isOnlineAuthApi(baseUrl) ? '/api' : ''
}

export const businessApiBaseUrl =
  process.env.VUE_APP_BUSINESS_API_BASE_URL ||
  process.env.VUE_APP_API_BASE_URL ||
  'https://vip.fleetan.com'

export const authApiBaseUrl =
  process.env.VUE_APP_AUTH_API_BASE_URL ||
  businessApiBaseUrl

export const authApiPrefix = resolveAuthApiPrefix(authApiBaseUrl)

export const toborderApiBaseUrl =
  process.env.VUE_APP_TOBORDER_API_BASE_URL ||
  '/toborder'

export const uploadApiBaseUrl =
  normalizeBaseUrl(businessApiBaseUrl) === 'https://cnvip.fleetan.com'
    ? 'https://cnvip.fleetan.com'
    : 'https://vip.fleetan.com'

export function buildAuthApiPath(path) {
  return `${authApiPrefix}${normalizePath(path)}`
}
